import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-servicing-inbox',
  templateUrl: './servicing-inbox.component.html',
  styleUrls: ['./servicing-inbox.component.scss']
})
export class ServicingInboxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  /* Data for Nodes */
  nodes = [
    {
      title   : 'My Service Requests',
      key     : '1',
      expanded: true,
      icon    : 'anticon anticon-user',
      children: [
        { title: 'All Requests ', key: '1001', icon: 'anticon anticon-profile', isLeaf: true },
        { title: 'Starred Requests', key: '1001', icon: 'anticon anticon-star', isLeaf: true },
      ]
    },
    {
      title   : 'Financial Endorsements',
      key     : '2',
      expanded: true,
      //icon    : 'anticon anticon-user',
      children: [
        { title: 'Date of Birth Change', key: '1001', isLeaf: true },
        { title: 'PIN Code Change', key: '1001', isLeaf: true },
      ]
    },
    {
      title   : 'Non-Financial Endorsements',
      key     : '3',
      expanded: true,
      //icon    : 'anticon anticon-user',
      children: [
        { title: 'Address Change', key: '1001', isLeaf: true },
        { title: 'Telephone Num Change', key: '1001', isLeaf: true },
        { title: 'Name Change', key: '1001', isLeaf: true },
      ]
    },
  ];
  treeClick(data:any){
    console.log("treeClick Data:", data);
    this.loadFaker();
  }
  isLoading = false;
  loadFaker = function() {
    this.isLoading = true;
    setTimeout(() => { this.isLoading = false }, 1250);
  };


  radioValue = 'myCases';

  loadCases(section:string='myCases'){
    this.treeClick({id:0});
  }

}
